import { render, staticRenderFns } from "./ResolutionRulesTab.vue?vue&type=template&id=09891968&scoped=true&"
import script from "./ResolutionRulesTab.vue?vue&type=script&lang=js&"
export * from "./ResolutionRulesTab.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionRulesTab.vue?vue&type=style&index=0&id=09891968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09891968",
  null
  
)

export default component.exports